import { brl } from "./format";

export const CATEGORIES = { vt: "Vale-transporte", vr: "Vale-refeição", va: "Vale-alimentação", saude: "Saúde", odonto: "Odontológico", seguro: "Seguro", auxilio: "Auxílio", outro: "Outro" };
export const CALC = { diario: "Valor diário", mensal: "Valor mensal", semanal: "Valor semanal", fixo: "Valor fixo", dia_util: "Por dia útil", outra: "Outra regra" };
export const PERIODS = { diaria: "Diária", semanal: "Semanal", quinzenal: "Quinzenal", mensal: "Mensal", competencia: "Por competência", utilizacao: "Por utilização", outra: "Outra" };
export const DISCOUNT = { fixo: "Valor fixo", percentual: "Percentual", outro: "Outro critério" };
export const SUPPLIERS = ["Alelo", "Ticket", "VR Benefícios", "Sodexo/Pluxee", "Unimed", "Bradesco Saúde", "SulAmérica", "Amil", "OdontoPrev"];
const DAILY = ["diario", "dia_util"];
const UNIT = { diario: "/dia", dia_util: "/dia útil", semanal: "/semana", mensal: "/mês" };
export const isDaily = (m) => DAILY.includes(m);
export const isPlan = (c) => c === "saude" || c === "odonto";
export const isPerDay = (c) => c === "vt" || c === "vr";

// Estimativa mensal (não é cálculo de folha) — espelha routes_benefit_policy.estimate
export function estimate(b) {
  let unit = Number(b.unit_value || 0);
  if (b.category === "vt" && b.trips_per_day && b.fare) unit = Number(b.trips_per_day) * Number(b.fare);
  const days = Number(b.days ?? b.default_days ?? 0);
  const m = b.calc_mode;
  let value = isDaily(m) ? unit * days : m === "semanal" ? unit * 4 : unit;
  if (b.dependents && b.dependent_value) value += Number(b.dependents) * Number(b.dependent_value);
  let disc = 0;
  if (b.has_discount && b.discount_value) {
    const dv = Number(b.discount_value);
    disc = b.discount_type === "percentual" ? (value * dv) / 100 : b.discount_type === "outro" ? 0 : isDaily(m) ? dv * days : m === "semanal" ? dv * 4 : dv;
  }
  return [Math.round(value * 100) / 100, Math.round(disc * 100) / 100];
}

export function describe(b) {
  const days = b.days ?? b.default_days;
  let unit = Number(b.unit_value || 0);
  if (b.category === "vt" && b.trips_per_day && b.fare) unit = Number(b.trips_per_day) * Number(b.fare);
  const parts = [isDaily(b.calc_mode) && days ? `${brl(unit)}${UNIT[b.calc_mode]} × ${days} dias` : `${brl(unit)}${UNIT[b.calc_mode] || ""}`];
  if (b.plan_name) parts.push(b.plan_name);
  return parts.join(" · ");
}

export function discountText(b) {
  if (!b.has_discount) return "Sem desconto";
  if (b.discount_type === "percentual") return `Desconto ${b.discount_value || 0}%`;
  if (b.discount_type === "outro") return `Desconto: ${b.discount_note || "outro critério"}`;
  return `Desconto ${brl(b.discount_value || 0, 2)}${UNIT[b.calc_mode] || ""}`;
}
